import React from 'react';
import './kessler-assessment-result.scss';

interface KesslerAssessmentResultProps {
    score: number;
}

const KesslerAssessmentResult: React.FC<KesslerAssessmentResultProps> = ({ score }) => {
    const [percentage, setPercentage] = React.useState<number>(0);
    const [position, setPosition] = React.useState<number>(0);

    React.useEffect(() => {
        const percent = Math.round((score * 100) / 50);
        let xPos = ((percent * 492) / 100) - 7.6;
        if (score >= 50) {
            xPos -= 4.2;
        } else if (score === 10) {
            xPos += 8;
        }
        setPercentage(percent)
        setPosition(xPos);
    }, [score]);

    const getColor = () => {
        if (score >= 0 && score <= 19) {
            return 'rgb(171, 255, 171)'; // Minimal Distress
        } else if (score >= 20 && score <= 24) {
            return 'rgb(240, 226, 45)'; // Mild Distress
        } else if (score >= 25 && score <= 29) {
            return 'rgb(251, 172, 14)'; // Moderate Distress
        } else {
            return 'rgb(228, 78, 58)'; // Severe Distress
        }
    };

    const minX = 20;
    const Xposition = (position * 100) / 492;
    const percentageAnimation: any = { '--percentage': `${percentage}%` };
    const positionAnimation: any = { '--xPosition': `${Xposition}%` };

    return (
        <div className="kessler-assessment-result">
            <div className="kessler-result-container">
                <h1 className="result-title">Psychological Distress</h1>
                <div id="line-graph__anxiety">
                    <svg width="100%" height="44" fill="#E9ECF0">
                        <rect y="29" height="7" width="100%" />
                        <rect fill={getColor()} y="29" height="7" width="0%" className="progress-bar" style={percentageAnimation} />
                        <rect fill="#1A3266" x={`${minX}%`} y="21" rx="1" ry="1" height="44" width="2" />
                        <circle fill={getColor()} cx="0%" cy="32" r="8" className="slider" style={positionAnimation} />
                        <text x={`${score >= 50 ? Xposition - 4 : Xposition}%`} y="12" className={'score__text'}>
                            {score}/50
                        </text>
                    </svg>
                </div>
                <div className="distress-levels">
                    <div className="distress-level">Minimal</div>
                    <div className="distress-level">Severe</div>
                </div>
                <div className="clinical-level">
                    <div style={{ borderLeft: '2px solid rgb(26, 50, 102)' }}>Clinical Level</div>
                </div>
            </div>
        </div>
    );
};

export default KesslerAssessmentResult;
